import { parse } from 'date-fns';
import { FormFieldName, FormModel } from '../form';
import { DATE_VALUE_FORMAT } from '../const';

export const getDateFromValue = (dateValue: FormModel[FormFieldName.Date]): Date | undefined => {
  return dateValue ? parse(dateValue, DATE_VALUE_FORMAT, new Date()) : undefined;
};
